import { api } from 'common';

import { SharedRestBlockFormFields } from './Shared/FormFields';
import { sharedRestBlockDefaultConfig } from './Shared/constants';
import { restBlockDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';
import { SharedRestNodeOutputContent } from './Shared/OutputContent';
type RestBlockConfig = api.FlowDefinition.RestBlock['config'];

export const restBlockConfig: BlockConfigProps<RestBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'restApi',
  defaultConfig: sharedRestBlockDefaultConfig,
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [
          ...(config.headers?.map((header) => header.value) ?? []),
          config.params,
          config.body,
        ],
      };
    },
    schema: api.FlowDefinition.RestBlockConfigSchema,
    FormFields: SharedRestBlockFormFields,
  },
  OutputContentComponent: SharedRestNodeOutputContent,
  documentationMarkdown: restBlockDocumentationMarkdown,
};
